import storageService from '../services/storageService'
import { SortTypes } from './constants'
import allLocales from '../i18n/locales'
import { useLocalePathPrefix } from './getWebsiteUrl'

export const generateUEID = () => {
  let first = (Math.random() * 46656) | 0
  let second = (Math.random() * 46656) | 0
  first = ('000' + first.toString(36)).slice(-3)
  second = ('000' + second.toString(36)).slice(-3)

  return first + second
}

export const parseQueryString = (string) => {
  return string
    .slice(1)
    .split('&')
    .map((queryParam) => {
      const kvp = queryParam.split('=')
      return { key: kvp[0], value: kvp[1] }
    })
    .reduce((query, kvp) => {
      query[kvp.key] = kvp.value
      return query
    }, {})
}

export const removeLocaleFromURL = (url) => {
  if (!useLocalePathPrefix && url) return url
  if (!url) return '/'
  if (!url.includes('?') && url.charAt(url.length - 1) != '/') url += '/'

  Object.keys(allLocales).forEach((locale) => {
    url = url.replaceAll(`/${locale}/`, '/')
  })
  return url || '/'
}

export const removeHTMLFromString = (string) => {
  if (!isBrowser()) return
  const tmp = document.createElement('div')
  tmp.innerHTML = string
  return tmp.textContent || tmp.innerText || ''
}

export const sortGames = (games, sortKeyword) => {
  const safeGames = [...games]

  switch (sortKeyword) {
    case SortTypes.A_Z:
      return safeGames.sort((a, b) => a.title.localeCompare(b.title))
    case SortTypes.Z_A:
      return safeGames.sort((a, b) => b.title.localeCompare(a.title))
    case SortTypes.NEWEST_OLDEST:
      return safeGames.sort((a, b) => a.created_at.localeCompare(b.created_at))
    case SortTypes.OLDEST_NEWEST:
      return safeGames.sort((a, b) => b.created_at.localeCompare(a.created_at))
    case SortTypes.POPULAR:
      return safeGames.sort((a) =>
        a.game_tags?.includes('gametag_top') ? -1 : 0
      )
    default:
      return safeGames
  }
}

export const getCasinoBackLink = (casinoSlug, liveCasinoSlug) => {
  const lobby = storageService.getValue('lobby')

  if (lobby?.includes(liveCasinoSlug)) {
    return `/${liveCasinoSlug}/`
  } else {
    return `/${casinoSlug}/`
  }
}

/**
 * Checks if the code is running in a browser environment.
 *
 * @returns {boolean} Returns `true` if in a browser environment, otherwise `false`.
 */
export const isBrowser = () => {
  return typeof window !== 'undefined'
}

export const isMobile = () => {
  if (typeof window === 'undefined') return false
  return Boolean(
    window.navigator.userAgent.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    )
  )
}

export const detectBrowser = () => {
  if (typeof window === 'undefined') return 'unknown'

  const { userAgent, userAgentData } = window.navigator

  if (userAgentData && userAgentData.brands) {
    const brand = userAgentData.brands.map((b) => b.brand).join(' ')
    if (brand.includes('Edge')) return 'Edge'
    if (brand.includes('Chrome')) return 'Chrome'
    if (brand.includes('Firefox')) return 'Firefox'
    if (brand.includes('Safari')) return 'Safari'
  }

  if (userAgent.includes('Edg')) return 'Edge'
  if (userAgent.includes('Chrome')) return 'Chrome'
  if (userAgent.includes('Firefox')) return 'Firefox'
  if (userAgent.includes('Safari')) return 'Safari'
  if (userAgent.includes('Opera')) return 'Opera'
  if (userAgent.includes('Trident') || userAgent.includes('MSIE'))
    return 'Internet Explorer'

  return 'unknown'
}
